import { combineReducers } from 'redux'
import stagedRecord from './stagedRecord'

export default combineReducers({
  stagedRecord,
})
